import { selectUserHasIterableEmail } from 'core/userContext';
import { useSelector } from 'react-redux';
import {
  serializationOptionsForBooleanValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';

export const useIsDevPanelEnabled = () => {
  const [isDevPanelUrlParamEnabled] = useSearchParamState({
    searchParamKey: 'dev-panel',
    stateValueWhenSearchParamIsUnset: false,
    ...serializationOptionsForBooleanValue,
  });

  const hasIterableEmail = useSelector(selectUserHasIterableEmail);

  return hasIterableEmail && isDevPanelUrlParamEnabled;
};
